import axiosInstance from '@/lib/axios/axiosInstance'
import { apiPath } from '@/constants/api-paths'
import type { ResponseContentEntity } from '@/models/response-types'
import type { CreateProviderPayload, User } from '@/services/users'

export const profileApi = {
  getCurrent: async () => {
    const response = (await axiosInstance.get(
      apiPath.PROVIDER_PROFILE,
    )) as unknown as ResponseContentEntity<User>
    return response.data
  },

  // PUT /api/master/provider/profile — edit the signed-in clinician's profile
  updateCurrent: async (payload: CreateProviderPayload) => {
    const response = (await axiosInstance.put(
      apiPath.PROVIDER_PROFILE,
      payload,
    )) as unknown as ResponseContentEntity<User>
    return response.data
  },
}
